import { ampli } from "@/ampli"
import { ConnectOrMessageButton } from "@/components/ConnectOrMessageButton"
import { InviteToAJobDialog } from "@/components/InviteToJobDialog"
import { Button } from "@/elements"
import { FragmentType, graphql, useFragment } from "@/gql"
import { UserConnectionStatus } from "@/gql/graphql"
import type { NovaSession } from "@/types"
import React, { FC } from "react"

const MessageAndInviteDialogButtonsFragment = graphql(`
  fragment MessageAndInviteDialogButtons on IndividualCreative {
    __typename
    id
    user {
      __typename
      id
      uuid
      viewerConnectionStatus
      ...ConnectOrMessageButton
    }
    ...InviteToAJobDialog
  }
`)

interface Props {
  onOpenDialog: () => void
  onClickMessage?: () => void
  onCloseDialog: () => void
  onClickInviteToJob?: () => void
  dialogOpen: boolean
  trackingEntryPoint: string
  creative: FragmentType<typeof MessageAndInviteDialogButtonsFragment> | undefined | null
  serverSession: NovaSession
}

export const MessageAndInviteDialogButtons: FC<Props> = props => {
  const { onOpenDialog, onCloseDialog, dialogOpen, serverSession, trackingEntryPoint } = props
  const creative = useFragment(MessageAndInviteDialogButtonsFragment, props.creative)
  const user = creative?.user

  const status = user?.viewerConnectionStatus

  return (
    <div className="flex w-full flex-row items-center justify-between">
      <div className="flex flex-row items-center gap-x-2">
        <ConnectOrMessageButton
          layout="row"
          user={user}
          trackingEntryPoint={trackingEntryPoint}
          serverSession={serverSession}
        />
        {status !== UserConnectionStatus.ConnectionRequestReceived && (
          <InviteToAJobDialog
            creative={creative}
            modalOpen={dialogOpen}
            trackingEntryPoint={trackingEntryPoint}
            onModalClose={onCloseDialog}
            trigger={
              <Button
                onClick={e => {
                  e.preventDefault()
                  e.stopPropagation()
                  onOpenDialog()
                }}
                data-prevent-nprogress={true}
                variant="tertiary">
                Invite to Job
              </Button>
            }
          />
        )}
      </div>
    </div>
  )
}
